export default "__VITE_PUBLIC_ASSET__985a3320__"